<template>
    <b-card :title="title">
        <!-- Details Dialog -->
        <export-details-dialog :query-data="queryModel" ref="detailsDialog" />
        <b-card-header>
            <b-row>
                <b-col>
                    <b-form-input
                        type="search"
                        placeholder="Search Assets..."
                        v-model="query"
                    ></b-form-input>
                </b-col>

                <b-col cols="3">
                    <b-button
                        variant="light"
                        v-if="hasPermissionView"
                        @click="toggle_filters = !toggle_filters"
                    >
                        Filters
                        <b-icon
                            :icon="
                                'chevron-' + (toggle_filters ? 'up' : 'down')
                            "
                            variant="dark"
                        ></b-icon>
                    </b-button>
                </b-col>

                <b-col class="text-right">
                    <slot></slot>
                </b-col>
            </b-row>

            <asset-query-builder
                v-show="toggle_filters"
                v-model="filters"
                :asset-types="types"
            />
        </b-card-header>
        <b-card-body>
            <p class="mt-3">
                Page: {{ pagination.page }} of {{ pageCount }} Total:
                {{ pagination.total }}
            </p>
            <b-table
                :fields="assetFields"
                striped
                hover
                responsive
                :items="items"
            >
                <template #cell(id)="row">
                    <b-button
                        size="sm"
                        v-if="hasPermissionView"
                        @click="viewAsset(row.item.id)"
                        class="mr-2"
                        variant="primary"
                    >
                        View
                    </b-button>
                </template>

                <template #cell(frequency)="{ value }">
                    <span>{{ getFrequencyType(value) }}</span>
                </template>
            </b-table>
            <b-row>
                <b-col>
                    <b-pagination
                        class="float-right"
                        v-model="pagination.page"
                        :total-rows="pagination.total"
                        :per-page="pagination.pageSize"
                        aria-controls="assetTable"
                        pills
                        align="right"
                    ></b-pagination>
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
</template>

<script>
import _ from 'lodash'
import popupMixins from '@/mixins/popupMixins'
import AssetQueryBuilder from './AssetQueryBuilder'
import ExportDetailsDialog from './ExportDetailsDialog'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'assets-itemList',
    components: { AssetQueryBuilder, ExportDetailsDialog },
    props: ['type', 'items', 'title'],
    mixins: [popupMixins, permissionsMixins],
    data() {
        return {
            query: '',
            toggle_filters: false,
            filters: { type_id: 0 },
            assetFields: [
                {
                    key: 'id',
                    label: '',
                    stickyColumn: true,
                },
                'name',
                'model_no',
                'serial_no',
                {
                    key: 'type_id',
                    label: 'Type',
                    formatter: (value, key, item) => item.type.name,
                },
                { key: 'last_service_date', label: 'Last Service' },
                { key: 'next_service_date', label: 'Next Service' },
                { key: 'warranty_expiry_date', label: 'Warranty' },
                { key: 'contract_expiry_date', label: 'ContractExp' },
                'frequency',
                {
                    key: 'customer_id',
                    label: 'Customer',
                    formatter: (value, key, item) => item.customer.name,
                },
                {
                    key: 'location_section_id',
                    label: 'Location',
                    formatter: (value, key, item) =>
                        (x => x.name + ', ' + x.location.address1)(
                            item.location_section
                        ),
                },
            ],
        }
    },

    mounted() {
        console.log('items', this.items)
        if (this.$route.query.query) this.query = this.$route.query.query
        this.doSearch()
    },
    computed: {
        types() {
            return [{ name: 'Any', id: 0 }].concat(
                this.$store.state.assets.types
            )
        },
        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize)
        },
        pagination() {
            return this.$store.state.assets.assets_pagination
        },
        user() {
            return this.$store.state.user
        },

        queryModel() {
            const { query } = this
            return { query, ...this.filters }
        },
    },

    watch: {
        'pagination.page': function (newPage) {
            this.changePage(newPage)
        },
        filters: {
            handler: function (filters) {
                console.log('filters', filters)
                this.doSearch()
            },
            deep: true,
        },
        query: _.debounce(function (query) {
            this.query = query
            this.$router.push({ query: { query: this.query } })
            this.doSearch()
        }, 200),
    },

    methods: {
        viewAsset(id) {
            const path = `${this.$route.path}/${id}`
            this.$router.push({ path })
        },

        changePage(page) {
            this.$router.push({ query: { page } })
            this.doSearch()
        },
        doSearch() {
            const { query, pagination: { page }, filters } = this
            this.$store.dispatch('assets/fetch', {
                query,
                page,
                filters,
            })
        },
        showDetailsDialog() {
            this.$refs.detailsDialog.show(this.queryModel)
        },
        getFrequencyType(value) {
            const { frequencies } =
                this.$store.getters['company/assetFrequencies']
            const obj = (frequencies || []).find(x => x.value == value)
            if (obj) {
                return obj.name
            } else return ''
        },
    },
}
</script>
<style></style>
